import { render } from "./VendasPeriodo.vue?vue&type=template&id=03183e37"
import script from "./VendasPeriodo.vue?vue&type=script&lang=js"
export * from "./VendasPeriodo.vue?vue&type=script&lang=js"

import "./VendasPeriodo.vue?vue&type=style&index=0&id=03183e37&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__